import { FaFacebook, FaTwitter, FaLinkedin, FaInstagram } from "react-icons/fa";
import { Link } from "react-router-dom";
import { FiMail, FiPhone, FiMapPin } from "react-icons/fi";
import logo from "../assets/img/logo2.png";

export default function Footer() {
  const currentYear = new Date().getFullYear();

  const footerSections = [
    {
      title: "Product",
      links: [
        { name: "Features", href: "/#features", isRoute: true },

        { name: "Free Trial", href: "/login" },
      ],
    },
    {
      title: "Support",
      links: [
        { name: "Help Center", href: "#help" },
        { name: "Contact Us", href: "/contact", isRoute: true },
      ],
    },
    {
      title: "Legal",
      links: [
        { name: "Privacy Policy", href: "#privacy" },
        { name: "Terms of Service", href: "#terms" },
        { name: "Security", href: "#security" },
      ],
    },
  ];

  const socialLinks = [
    {
      icon: <FaFacebook className="text-lg sm:text-xl" />,
      href: "#",
      label: "Facebook",
    },
    {
      icon: <FaTwitter className="text-lg sm:text-xl" />,
      href: "#",
      label: "Twitter",
    },
    {
      icon: <FaLinkedin className="text-lg sm:text-xl" />,
      href: "#",
      label: "LinkedIn",
    },
    {
      icon: <FaInstagram className="text-lg sm:text-xl" />,
      href: "#",
      label: "Instagram",
    },
  ];
  const contactMethods = [
    {
      icon: <FiMail className="text-orange-500 text-xl sm:text-2xl" />,
      title: "Email Us",
      detail: "easidine@gmail.com",
      action: "mailto:easidine@gmail.com",
    },
    {
      icon: <FiPhone className="text-orange-500 text-xl sm:text-2xl" />,
      title: "Call Us",
      detail: "+91 8073459731",
      action: "tel:+918073459731",
    },
    {
      icon: <FiMapPin className="text-orange-500 text-xl sm:text-2xl" />,
      title: "Visit Us",
      detail:
        "Bengaluru, Karnataka 560034",
      action:
        "https://www.google.com/maps/dir//6,+HSR+MAIN+ROAD,+7TH,+Jakkasandra+Cross+Rd,+1st+Block+Koramangala,+Koramangala,+Bengaluru,+Karnataka+560034/@12.9223542,77.5547562,12z/data=!4m8!4m7!1m0!1m5!1m1!1s0x3bae15707fcb48ab:0x567ddf7faa8eef90!2m2!1d77.6371581!2d12.9223671!5m1!1e1?entry=ttu",
    },
  ];
  return (
    <footer className="bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-20 left-10 w-24 sm:w-32 h-24 sm:h-32 bg-orange-500 rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 right-10 w-32 sm:w-40 h-32 sm:h-40 bg-red-500 rounded-full blur-3xl"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 relative z-10">
        {/* Main Footer Content */}
        <div className="py-12 sm:py-16">
          <div className="grid grid-cols-3 md:grid-cols-2 lg:grid-cols-5 gap-4 sm:gap-6 md:gap-8">
            {/* Company Info */}
            <div className="col-span-3 md:col-span-2 lg:col-span-2">
              <div className="flex items-center gap-2 sm:gap-3 mb-4 sm:mb-6">
                <img
                  src={logo}
                  alt="EasiDine Logo"
                  className="h-16 sm:h-20 md:h-24 lg:h-[100px] w-auto object-contain -my-1 sm:-my-2"
                  style={{ maxHeight: "none" }}
                />
              </div>

              <p className="text-gray-300 mb-4 sm:mb-6 leading-relaxed text-sm sm:text-base">
                Transform your restaurant operations with our comprehensive QR
                code ordering system. Manage menus, track orders, and boost
                customer satisfaction with cutting-edge technology.
              </p>

              {/* Social Media */}
              <div>
                <h4 className="text-base sm:text-lg font-semibold mb-2 sm:mb-3">
                  Follow Us
                </h4>
                <div className="flex gap-3 sm:gap-4">
                  {socialLinks.map((social, index) => (
                    <a
                      key={index}
                      href={social.href}
                      className="w-8 h-8 sm:w-10 sm:h-10 bg-gray-800 hover:bg-gradient-to-r hover:from-orange-500 hover:to-red-500 rounded-lg flex items-center justify-center text-gray-400 hover:text-white transition-all duration-300 hover:scale-110"
                      aria-label={social.label}
                    >
                      {social.icon}
                    </a>
                  ))}
                </div>
              </div>
            </div>

            {/* Footer Links - Now in 3 columns on mobile */}
            {footerSections.map((section, index) => (
              <div
                key={index}
                className="flex flex-col items-center sm:items-start"
              >
                <h4 className="text-base sm:text-lg font-semibold mb-3 sm:mb-4 text-white text-center sm:text-left">
                  {section.title}
                </h4>
                <ul className="space-y-2 sm:space-y-3 text-center sm:text-left">
                  {section.links.map((link, linkIndex) => (
                    <li key={linkIndex}>
                      {link.isRoute ? (
                        <Link
                          to={link.href}
                          className="text-gray-400 hover:text-orange-400 transition-colors duration-300 hover:translate-x-1 inline-block text-sm sm:text-base"
                        >
                          {link.name}
                        </Link>
                      ) : (
                        <a
                          href={link.href}
                          className="text-gray-400 hover:text-orange-400 transition-colors duration-300 hover:translate-x-1 inline-block text-sm sm:text-base"
                        >
                          {link.name}
                        </a>
                      )}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        {/* Contact Info */}
        <div className="border-t border-gray-700 py-6 sm:py-8">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
            {contactMethods.map((method, idx) => (
              <a
                key={idx}
                href={method.action}
                className="flex items-start gap-2 sm:gap-3 group"
                target={method.title === "Visit Us" ? "_blank" : undefined}
                rel={
                  method.title === "Visit Us"
                    ? "noopener noreferrer"
                    : undefined
                }
              >
                <div className="w-8 h-8 sm:w-10 sm:h-10 bg-gradient-to-r from-orange-500 to-red-500 rounded-lg flex items-center justify-center group-hover:scale-110 transition-transform flex-shrink-0 mt-0.5">
                  {method.icon}
                </div>
                <div className="min-w-0 flex-1">
                  <p className="font-medium text-sm sm:text-base">
                    {method.title}
                  </p>
                  <p className="text-gray-400 text-xs sm:text-sm break-words">
                    {method.detail}
                  </p>
                </div>
              </a>
            ))}
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-700 py-4 sm:py-6">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-3 sm:gap-4">
            <div className="text-gray-400 text-xs sm:text-sm">
              © {currentYear} EASIDINE. All rights reserved.
            </div>

            <div className="flex items-center gap-4 sm:gap-6 text-xs sm:text-sm">
              <span className="text-gray-400">
                Trusted by 10+ restaurants India wide
              </span>
              <div className="flex items-center gap-1.5 sm:gap-2">
                <div className="w-1.5 h-1.5 sm:w-2 sm:h-2 bg-green-500 rounded-full animate-pulse"></div>
                <span className="text-green-400">99.9% Uptime</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
